module.exports = __webpack_public_path__ + "img/20200507_135602.07f9dd4a.jpg";